// extracted by mini-css-extract-plugin
export var actionText = "_j9-4";
export var container = "_j9-0";
export var leftSection = "_j9-1";
export var rightSection = "_j9-2";
export var settingsButton = "_j9-6";
export var settingsIcon = "_j9-7";
export var shortcut = "_j9-5";
export var shortcutGroup = "_j9-3";